<div class="notification" [formGroup]="form">
  <mat-form-field appearance="fill">
    <mat-label>{{ 'common.type' | t }}</mat-label>
    <mat-select
      formControlName="notificationType"
      [placeholder]="'map.tools.createSentryDialog.notificationType' | t"
      required
    >
      <mat-option
        *ngFor="let notificationType of notificationTypes; trackBy: trackNotificationType"
        [value]="notificationType"
      >
        {{ 'settings.notificationGroups.notificationTypes.' + notificationType | t }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{ 'common.user' | t }}</mat-label>
    <sn-user-select
      [selectedOptions]="options"
      required
      formControlName="user"
      [placeholder]="'map.tools.createSentryDialog.selectUser' | t"
    ></sn-user-select>
  </mat-form-field>

  <sn-icon-button class="notification__delete-btn" (click)="deleteNotification()">
    <sn-icon size="sm">clear</sn-icon>
  </sn-icon-button>
</div>
